export const ADD_GROUP = 'ADD_GROUP'
export const DELETE_GROUP = 'DELETE_GROUP'
export const SET_GROUP = 'SET_GROUP'
export const SET_GROUPS = 'SET_GROUPS'
export const RESET_GROUP = 'RESET_GROUP'



// WEBPACK FOOTER //
// ./src/store/modules/group/types.js